import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const whiteList = ['/login']

function findFirstValidRoute(routes, basePath = '') {
    for (const route of routes) {
        // 跳过隐藏路由和 404
        if (route.hidden || route.path === '*') continue

        // 解析完整路径
        let fullPath = route.path
        if (!fullPath.startsWith('/')) {
            // 处理相对路径拼接
            fullPath = basePath + (basePath.endsWith('/') ? '' : '/') + fullPath
        }

        // 如果有子菜单，递归查找
        if (route.children && route.children.length > 0) {
            const childPath = findFirstValidRoute(route.children, fullPath)
            if (childPath) return childPath
        } else {
            // 是叶子节点（菜单），返回路径
            return fullPath
        }
    }
    return null
}

router.beforeEach(async(to, from, next) => {
    NProgress.start()
    const hasToken = localStorage.getItem('token')

    if (hasToken) {
        if (to.path === '/login') {
            next({ path: '/' })
            NProgress.done()
        } else {
            const hasRoutes = store.state.hasLoadedRoutes

            if (hasRoutes) {
                if (to.path === '/') {
                    const dashboardRoute = store.state.routes.find(r => r.path === '/dashboard')
                    if (dashboardRoute) {
                        next({ path: '/dashboard', replace: true })
                        NProgress.done()
                        return
                    }
                    const firstRoute = findFirstValidRoute(store.state.routes)
                    if (firstRoute) {
                        next({ path: firstRoute, replace: true })
                    } else {
                        // 如果没有任何菜单，就显示 404 或空白
                        next() 
                    }
                } else {
                    next()
                }
            } else {
                try {
                    const accessRoutes = await store.dispatch('GenerateRoutes')
                    
                    if (router.addRoutes) {
                        router.addRoutes(accessRoutes)
                    } else {
                        accessRoutes.forEach(r => router.addRoute(r))
                    }

                    // 加载完路由后，重新进入当前页面，触发上面的 path === '/' 逻辑
                    next({ ...to, replace: true })
                } catch (error) {
                    await store.dispatch('Logout')
                    next(`/login?redirect=${to.path}`)
                    NProgress.done()
                }
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next(`/login?redirect=${to.path}`)
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})
